import { render, staticRenderFns } from "./stu_LayoutAside1.vue?vue&type=template&id=3dfdb60a&scoped=true"
import script from "./stu_LayoutAside1.vue?vue&type=script&lang=js"
export * from "./stu_LayoutAside1.vue?vue&type=script&lang=js"
import style0 from "./stu_LayoutAside1.vue?vue&type=style&index=0&id=3dfdb60a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dfdb60a",
  null
  
)

export default component.exports